import { IParticipant } from 'twain-sport-fe-mono/interfaces';

const ranksStatistics = ['winningPercentage', 'pointsPerGame', 'accuracy', 'shotsPerGame'];
const getParticipantRanks = (participant: IParticipant): number[] => [
    participant.rank,
    ...ranksStatistics.map(
        (statistic) => participant.statistics.find((item) => item.name === statistic)?.rank,
    ),
];

export const getRandomFirstRank = (participant: IParticipant): number => {
    const ranks = getParticipantRanks(participant);
    const firstRanksSounds = ranks.reduce((acc, rank, index) => {
        if (rank === 1) {
            acc.push(index + 1);
        }

        return acc;
    }, []);

    return firstRanksSounds.length
        ? firstRanksSounds[Math.floor(Math.random() * firstRanksSounds.length)]
        : null;
};
